<template>
  <div class="menuSide">
    <el-menu
      :collapse="asideCollapse"
      :unique-opened="true"
      :default-active="active"
      ref="menu"
      @select="handleMenuSelect">
      <template v-for="(menu, menuIndex) in aside">
        <header-aside-menu-item v-if="menu.children === undefined" :menu="menu" :key="menuIndex"/>
        <header-aside-menu-sub v-else :menu="menu" :key="menuIndex"/>
      </template>
    </el-menu>
    <div v-if="aside.length === 0 && !asideCollapse">
      <span>没有侧栏菜单</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MainMenuItem from '../menu-item/index.vue'
import MainMenuSub from '../menu-sub/index.vue'
// import BScroll from 'better-scroll'
export default {
  name: 'header-aside-menu-side',
  components: {
    'header-aside-menu-item': MainMenuItem,
    'header-aside-menu-sub': MainMenuSub
  },
  data () {
    return {
      active: '',
      asideHeight: 300,
      BS: null
    }
  },
  computed: {
    ...mapState('d2admin/menu', [
      'aside',
      'asideCollapse'
    ])
  },
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    // asideCollapse (val) {
    //   this.scrollDestroy()
    //   setTimeout(() => {
    //     this.scrollInit()
    //   }, 500)
    // },
    // 监听路由 控制侧边栏激活状态
    '$route': {
      handler ({ fullPath }) {
        this.active = fullPath
        this.$nextTick(() => {
          if (this.aside.length > 0 && this.$refs.menu) {
            this.$refs.menu.activeIndex = fullPath
          }
        })
      },
      immediate: true
    }
  },
  // mounted () {
  //   this.scrollInit()
  // },
  // beforeDestroy () {
  //   this.scrollDestroy()
  // },
  methods: {
    handleMenuSelect (index, indexPath) {
      if (/^menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning('临时菜单')
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        // util.open(index)
      } else {
        this.$router.push({
          path: index
        })
      }
    }
  }
}
</script>

<style lang="scss">
.menuSide{
  width: 260px;
  height: 100%;
  background:#002140;
  box-shadow:2px 0px 6px 0px rgba(0,21,41,0.35);
  position: absolute;
  left: 0;
}
</style>
